import axios from 'axios';
import Lodash from 'lodash';
import uniqueId from 'lodash/uniqueId';

import {CustomNodeModel} from '../components/Channel/API/Logics/custom-diagram/CustomNodeModel'
import {CustomPortModel} from '../components/Channel/API/Logics/custom-diagram/CustomPortModel'

import getAxiosConfig from '../utils/axiosConfig';
import messageCodes from '../utils/messageCodes';

import {
    DefaultLinkModel,
    DiagramModel
} from "@projectstorm/react-diagrams";
import {distributeElements} from "../components/Channel/API/Logics/components/Dagre";

import defaultPredicateOption from '../components/NodeEditorPanel/components/Predicate/const/defaultPredicateOption';
import {createNodesCopies} from "./ClipboardManager";
import _ from "lodash";
import {
    defaultOptions
} from "../components/NodeEditorPanel/components/ModifierInputPortList/FieldModifier/components/defaultOptions";


function convertFromLegacy(oldOptions) {
    //if structure is old - rebuild;
    //make a copy of an old structure except of those fields that need to be changed; add new structure, transform to new one, return new;
    //if structure is already new - pass it
    return oldOptions;
}

export function setUpLogic(thisElement) {
    let node;
    const nodesPort = [];
    const {graphData} = thisElement.props;
    const {engine} = thisElement.state;
    const debugInfo = JSON.parse(localStorage.getItem("debugInfo"));

    graphData.nodes.forEach(v => {
        const nodesCount = Lodash.keys(engine.getModel().getNodes()).length;
        node = new CustomNodeModel(v.title, v.name, v.type, v.sectionType, nodesCount, this, v.blockDescription);

        const inputPort = v.ports.filter(port => port.input);
        const outputPort = v.ports.filter(port => !port.input);

        inputPort.forEach((value, index) => {
            const port = new CustomPortModel({
                in: true,
                id: value.id,
                name: `in-${index}`,
                label: index === 0 ? `#${v.name}${nodesCount + 1}` : ''});

            const portData = node.addPort(port);
            portData.selectID = value.id;
            nodesPort.push(portData);
        });

        outputPort.forEach((value, index) => {
            const port = new CustomPortModel({
                in: false,
                id: value.id,
                name: `out-${index}`,
                label: index === 0 ? `#${v.name}${nodesCount + 1}` : ''});

            const portData = node.addPort(port);
            portData.selectID = value.id;
            nodesPort.push(portData);
        });
        node.setPosition(v.options.viewData.x, v.options.viewData.y);
        node.getOptions().id = v.id;
        let options;
        if (v.name === "Field Modifier" || v.name === "Context Property Modifier") {
            options = convertFromLegacy(v.options);
        } else {
            options = v.options;
        }
        node.extras = {
            type: v.type,
            options: options,
            markAsUnused: shouldMarkNodeAsUnused(v.id, v.type, debugInfo)
        };
        engine.getModel().addNode(node);
    });

    const connectionLineCurviness = 50;
    graphData.edges.forEach(v => {
        const fromNode = v.fromPort.node,
            fromPort = v.fromPort.id,
            toNode = v.toPort.node,
            toPort = v.toPort.id;
        nodesPort.forEach((value) => {
            if (value.parent.getID() === fromNode && value.selectID === fromPort) {
                const link = new DefaultLinkModel();
                link.curvyness = connectionLineCurviness;
                value.connection = true;
                value.debugInfo = getOutputPortDebugInfo(value, debugInfo);
                link.setSourcePort(value);
                nodesPort.forEach((value) => {
                    if (value.parent.getID() === toNode && value.selectID === toPort) {
                        value.connection = true;
                        value.debugInfo = getInputPortDebugInfo(value, v, debugInfo);
                        if (!value.debugInfo && !value.parent.portsOut.length) {
                            value.debugInfo = link.getSourcePort().debugInfo
                        }
                        link.setTargetPort(value);
                        engine.getModel().addLink(link);
                    }
                });
            }
        });
    });

}

export function removeAndConnectTwoNodes(e, model, nodeData) {
    const entityData = e.entity;
    const nodeIDList = [];

    entityData.getLinks().forEach(link => {
        const sourcePort = link.getSourcePort();
        const targetPort = link.getTargetPort();
        if (sourcePort && targetPort && sourcePort.getOptions().in !== targetPort.getOptions().in) {
            nodeIDList.push({
                parentID: sourcePort.getParent().getID(),
                nodeName: sourcePort.getParent().nodeName,
                portID: sourcePort.getID(),
                in: sourcePort.getOptions().in,
                connectedPort: targetPort.getID()
            });
            nodeIDList.push({
                parentID: targetPort.getParent().getID(),
                nodeName: targetPort.getParent().nodeName,
                portID: targetPort.getID(),
                in: targetPort.getOptions().in,
                connectedPort: sourcePort.getID()
            });
        }
    });

    const inputPorts = nodeIDList.filter(value => value.in);

    inputPorts.forEach(value => {
        const connectedPortList = nodeIDList.filter(v => v.connectedPort === value.portID);
        if(connectedPortList.length > 1){
            const samePortID = connectedPortList[0].connectedPort;
            let removeIndexConnectionPort = nodeIDList.map(port => { return port.connectedPort; }).indexOf(samePortID);
            const removedPort = nodeIDList.splice(removeIndexConnectionPort, 1);
            removeIndexConnectionPort = nodeIDList.map(port => { return port.connectedPort; }).indexOf(removedPort[0].portID);
            nodeIDList.splice(removeIndexConnectionPort, 1);

            let removeProcess = false;
            model.getLinks().forEach(link => {
                if(!removeProcess && (link.getSourcePort().getID() === null || link.getTargetPort() === null || link.getSourcePort().getID() === samePortID || link.getTargetPort().getID() === samePortID)){
                    let linkPortID,
                    linkNodeID,
                    removedID,
                    removedPortID;

                    if (link.getSourcePort()) {
                        if(link.getSourcePort().getOptions().in){
                            linkPortID = link.getSourcePort().getID();
                            linkNodeID = link.getSourcePort().getParent().getID();
                        }else {
                            removedID = link.getSourcePort().getParent().getID();
                            removedPortID = link.getSourcePort().getID();
                        }
                    }
                    if (link.getTargetPort()) {
                        if(link.getTargetPort().getOptions().in){
                            linkPortID = link.getTargetPort().getID();
                            linkNodeID = link.getTargetPort().getParent().getID();
                        }else {
                            removedID = link.getTargetPort().getParent().getID();
                            removedPortID = link.getTargetPort().getID();
                        }
                    }

                    model.removeLink(link);
                    const deletedId = link.getID();
                    removeProcess = true;
                    model.getNodes().forEach(value => {
                        if(value.getID() === removedID){
                            Object.values(value.getPorts()).forEach((port) => {

                                Object.values(port.getLinks()).forEach(link => {
                                        if(link.getID() === deletedId){
                                            port.removeLink(link);
                                        }
                                    });
                            });
                        }
                        if(value.getID() === linkNodeID){
                            Object.values(value.ports).forEach((port) => {

                                Object.values(port.getLinks()).forEach(link => {
                                        if(link.getID() === deletedId){
                                            port.removeLink(link);
                                        }
                                    });
                            });
                        }
                    });
                }
            });
        }
    })

    const reducerNodeData = nodeData;
    const nodeNameList = Object.keys(reducerNodeData).filter(function (key) {
        return reducerNodeData[key].multiPort;
    });

    let resultPortData = [];
    nodeNameList.forEach(v => {
        const relatedData = nodeIDList.filter(node => node.nodeName === v);
        relatedData.forEach(v => resultPortData.push(v));
    });

    Object.values(model.getNodes()).forEach(nodeItem => {
        const result = nodeIDList.filter(node => node.parentID === nodeItem.getID());
        Object.keys(nodeItem.ports).forEach(function (index) {
            const portResult = result.filter(node => node.portID === nodeItem.ports[index].getID());
            nodeItem.ports[index].connection = portResult.length > 0;
        });

        resultPortData.forEach(v => {
            const outputPortResult = nodeIDList.filter(node => node.nodeName === v.nodeName && node.parentID === v.parentID);
            let outputPortID = outputPortResult.length > 0 ? outputPortResult[0].parentID : '';
            if (nodeItem.getID() === outputPortID) {

                const inputPort = Object.values(nodeItem.ports).filter(port => port.options.in);
                const outputResultInputCount = outputPortResult.filter(port => port.in).length;

                if (inputPort.length === outputResultInputCount) {
                    nodeItem.addInPort('In');
                    if (outputPortResult[0].nodeName !== 'switch') {
                        nodeItem.extras.options.inputPortData.push({
                            exclude: false,
                            group: uniqueId(),
                            itemCount: null,
                            logDecisionValue: "",
                            randomize: false,
                            useUnder: null
                        });
                    } else {
                        nodeItem.extras.options.inputPortData.push({
                            logDecisionValue: "",
                            predicate: {
                                type: "and",
                                predicates: [
                                    defaultPredicateOption
                                ]
                            },
                        });
                    }
                }
            }
        });
    });
}

export function createNewNode(thisElement, nodeData, title, type, sectionType, point) {
    const name = title;
    const model = thisElement.state.engine.getModel();
    const nodesCount = Lodash.keys(model.getNodes()).length,
        nodesData = nodeData.nodes[type],
        edges = nodeData.edges,
        options = nodeData.options,
        edgeID = nodesData ? nodesData.edgeID : '';
    const offsetY = model.getOffsetY();
    const offsetX = model.getOffsetX();
    const zoomLevel = model.getZoomLevel() / 100;
    const x = (350 / zoomLevel) - offsetX / zoomLevel;
    const y = (200 / zoomLevel) - offsetY / zoomLevel;
    const position = point || {x:x, y:y};

    let node = new CustomNodeModel(title, name, type, sectionType, nodesCount, this, new Map());

    if (edgeID !== '') {
        const result = edges.filter(value => value.id === edgeID)[0],
            outputCount = result.outputPorts,
            inputCount = typeof result.inputPorts === 'object' ? result.inputPorts[sectionType] : result.inputPorts ;

        for (let i = 0; i < outputCount; i++) {
            node.addOutPort('Out');
        }
        for (let i = 0; i < inputCount; i++) {
            node.addInPort('In');
        }
    } else {
        node.addOutPort('Out');
        node.addInPort('In');
    }

    node.setPosition(position.x, position.y);
    node.extras = {
        type: type,
        options: {
            viewData: {...position},
            changedMark: false
        }
    }

    if (nodesData) {
        const optionData = options.filter(option => option.id === nodesData.optionsID)[0];
        if (type === 'scoring') {
            optionData.scoringOptions.isFirstBlockModeEnabled = sectionType === 'first-blocks';
            optionData.scoringOptions.predicate_default = {
                type: "and",
                predicates: [defaultPredicateOption]
            }
        }

        if (type === 'search_first_block') {

            if (node?.extras?.options?.predicate) {
                delete node.extras.options.predicate;
            }

            optionData.scoringOptions = {
                ...optionData.scoringOptions,
                predictorContextItemsPropertyName: 'itemId',
                predictorContextUserPropertyName: 'itemId',
                predictorName: "SFB_PREDICTOR",
                isFirstBlockModeEnabled: true,
                isContextItemsPropertyNameSelected: false,
                isContextUserPropertyNameSelected: false,
                outputDynamicPropertyName: 'p',
                settings: {
                    ...optionData.scoringOptions?.settings
                },
                predicate_default: {
                    type: "and",
                    predicates: [defaultPredicateOption]
                }
            }
        }
        node.extras.options = {...node.extras.options, ...optionData};
    }
    thisElement.state.engine.getModel().addNode(node);
    thisElement.state.engine.repaintCanvas()
}

export function saveLogic(thisElement, logicId, isSave) {
    localStorage.removeItem("debugInfo");
    const model = thisElement.state.engine.getModel();
    const data = model.serialize();

    let nodeData = [],
        edgeData = [];

    let inputItemsNodeCount = 0;
    let unconnectedEdges = 0;
    let unmodifiedNodes = 0;
    let pagination;

    Object.values(data.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).forEach(v => {
        if (v.nodeName === 'input_items') inputItemsNodeCount++;
        if (v.nodeName === 'basic_output') pagination = v.extras.options.pagerOptions;

        const portData = [];
        const inPutPorts = v.ports.filter(value => value.in === true);
        const outputPorts = v.ports.filter(value => value.in === false);

        inPutPorts.forEach((port, index) => {
            portData.push({
                id: port.id,
                input: true,
                label: null,
                node: port.parentNode,
                portIndex: index
            });
        });
        outputPorts.forEach((port, index) => {
            portData.push({
                id: port.id,
                input: false,
                label: null,
                node: port.parentNode,
                portIndex: index
            });
        });

        let option = {}
        if (v.extras.options) {
            option = v.extras.options
            if (v.extras.options.changedMark === false && !['no_items', 'input_items'].includes(v.extras.type)) {
                unmodifiedNodes++;
            }
        }
        option.viewData = {
            x: v.x,
            y: v.y,
        }
        nodeData.push({
            component: null,
            inLogicId: v.id,
            id: v.id,
            name: v.name,
            options: option,
            sectionType: v.sectionType,
            title: v.title,
            type: v.nodeName,
            ports: portData
        });
    });


    Object.values(data.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach(v => {
        const sourceID = v.source;
        const sourcePortID = v.sourcePort;

        const selectNode = nodeData.filter(value => value.id === sourceID)[0];
        const portType = selectNode.ports.filter(value => value.id === sourcePortID)[0];

        let formPortID = v.sourcePort;
        let formNode = v.source;
        let toPortID = v.targetPort;
        let toNode = v.target;

        if (portType.input) {
            formPortID = v.targetPort;
            formNode = v.target;
            toPortID = v.sourcePort;
            toNode = v.source;
        }

        if (!formNode || !toNode) {
            unconnectedEdges++;
        }

        edgeData.push({
            id: v.id,
            fromPort: {
                id: formPortID,
                node: formNode
            },
            toPort: {
                id: toPortID,
                node: toNode
            }
        });

    });
    const graphData = thisElement.props.graphData;
    graphData.nodes = nodeData;
    graphData.edges = edgeData;
    graphData.data.contextProps = thisElement.props.contextProperties;
    graphData.data.contextUpdaters = thisElement.props.contextUpdaters;
    graphData.data.attributesToRetrieve = thisElement.props.attributesToRetrieve;
    graphData.data.contextPropertiesToRetrieve = thisElement.props.contextPropertiesToRetrieve;
    graphData.data.settingsToRetrieve = thisElement.props.settingsToRetrieve;
    graphData.data.pagination = pagination;

    const newGraphData = {
        ...graphData,
        scenarioId: graphData.logic.name,
        keyValues: []
    }

    if (inputItemsNodeCount === 0) newGraphData.logic.type = "MASTER";
    if (inputItemsNodeCount === 1) newGraphData.logic.type = "COMPONENT";
    if (inputItemsNodeCount > 1) {
        thisElement.props.showToastForFrontend(messageCodes.COMPONENT_SAVE_ERROR)
    } else if (unconnectedEdges > 0) {
        thisElement.props.showToastForFrontend(messageCodes.UNCONNECTED_EDGES_ERROR)
    } else if (unmodifiedNodes > 0) {
        thisElement.props.showToastForFrontend(messageCodes.UNMODIFIED_NODES_ERROR)
    } else {
        removeEmptyFields(newGraphData)
        axios.post(thisElement.props.properties.logicUrl + "/" + logicId, newGraphData, getAxiosConfig())
            .then((result) => {
                if (result) {
                    thisElement.props.updateGraphData(result.data);
                    if (isSave) {
                        thisElement.props.showToastForFrontend(
                            messageCodes.LOGIC_SAVED);
                    } else {
                        thisElement.props.showToastForFrontend(
                            messageCodes.LOGIC_SWITCHED);
                    }
                }
            }).catch((err) => {
            if (err.response) {
                thisElement.props.showToastForBackend(err.response.data);
            }
        });
    }
}

export function copySelected(thisElement) {
    const engine = thisElement.state.engine;
    const model = engine.getModel();
    const selectedNodes = model.getSelectedEntities().filter(item => item instanceof CustomNodeModel);

    if (selectedNodes.filter(node => node.nodeName === "basic_output").length) {
        thisElement.props.showToastForFrontend(messageCodes.CLONE_ERROR);
    } else {
        thisElement.props.setNodesCopied(selectedNodes.length)
        const newNodes = [];
        const allLinks = [];
        const connectedLinks = [];
        const linkMap = new Map();
        model.clearSelection();
        selectedNodes.forEach(node => {
            Object.values(node.getPorts()).forEach(port => {
                Object.values(port.getLinks()).forEach(link => {
                    if (allLinks.includes(link)) {
                        connectedLinks.push(link);
                        const sourceAndTargetIndexes = [];// sourceNodeIndex, targetNodeIndex, sourcePortIndex, targetPortIndex
                        const sourcePortIndex = Object.values(link.getSourcePort().getParent().getPorts()).indexOf(link.getSourcePort());
                        const targetPortIndex = Object.values(link.getTargetPort().getParent().getPorts()).indexOf(link.getTargetPort());
                        sourceAndTargetIndexes.push(selectedNodes.indexOf(link.getSourcePort().getParent()));
                        sourceAndTargetIndexes.push(selectedNodes.indexOf(link.getTargetPort().getParent()));
                        sourceAndTargetIndexes.push(sourcePortIndex);
                        sourceAndTargetIndexes.push(targetPortIndex);
                        linkMap.set(link, sourceAndTargetIndexes);
                    }
                    allLinks.push(link);
                });
            });
        });
        //Create new nodes
        Lodash.forEach(selectedNodes, (selectedNode) => {
            const newNode = selectedNode.clone({});
            newNode.number = Lodash.keys(engine.getModel().getNodes()).length;
            Object.values(newNode.getPorts()).forEach(port => {
                if (Object.keys(port.getLinks()).length === 0 && port.getLinks().constructor === Object) {
                    port.connection = false;
                }
            });
            newNode.setSelected(true);
            newNodes.push(newNode);
        });
        const {copiedNodes, copiedLinks, copiedLinkMap} = createNodesCopies(newNodes, connectedLinks, linkMap)
        thisElement.props.copyNodesActions(copiedNodes, copiedLinks, copiedLinkMap)
    }
    engine.repaintCanvas();
}

export function pasteSelected(thisElement) {
    const offset = {x: 60, y: 60};
    const engine = thisElement.state.engine;
    const model = engine.getModel();

    const copiedNode = thisElement.props.copyNodes;
    if (copiedNode.copiedNodes !== undefined && copiedNode.copiedLinks !== undefined && copiedNode.copiedLinkMap !== undefined) {
        const { copiedNodes, copiedLinks, copiedLinkMap } = createNodesCopies(copiedNode.copiedNodes, copiedNode.copiedLinks, copiedNode.copiedLinkMap);

        for (let i = 0; i < copiedNodes.length; i++) {
            if (model.getNode(copiedNodes[i].options.id) !== undefined){
                copiedNodes[i] = copiedNodes[i].clone({})
            }
            copiedNodes[i].setPosition(copiedNodes[i].getX() + offset.x, copiedNodes[i].getY() + offset.y);
            model.addNode(copiedNodes[i]);
        }

        for (let i = 0; i < copiedLinks.length; i++) {
            const newLink = copiedLinks[i].clone({});
            const sourceNodeIndex = copiedLinkMap.get(copiedLinks[i])[0];
            const targetNodeIndex = copiedLinkMap.get(copiedLinks[i])[1];
            const sourcePortIndex = copiedLinkMap.get(copiedLinks[i])[2];
            const targetPortIndex = copiedLinkMap.get(copiedLinks[i])[3];
            const sourcePort = Object.values(copiedNodes[sourceNodeIndex].getPorts())[sourcePortIndex];
            const targetPort = Object.values(copiedNodes[targetNodeIndex].getPorts())[targetPortIndex];
            newLink.getPoints().forEach((p) => {
                p.setPosition({x: p.getX() + offset.x, y: p.getY() + offset.y});
            });
            newLink.setSourcePort(sourcePort);
            newLink.setTargetPort(targetPort);
            sourcePort.connection = true;
            targetPort.connection = true;
            newLink.setSelected(true);
            model.addLink(newLink);
            copiedLinks[i] = newLink
        }
        engine.repaintCanvas();
    }
}

export function arrangeLogic(thisElement) {
    const engine = thisElement.state.engine;
    const graphData = thisElement.props.graphData;
    let distributedModel = getDistributedModel(engine);

    const model = new DiagramModel();
    engine.setModel(model);

    const nodeList = [];
    const portList = [];
    Object.values(distributedModel.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).forEach(node => {
        const portData = []

        node.ports.forEach(port => {
            portData.push({
                id: port.id,
                input: port.in,
                label: null,
                node: port.parentNode,
                portIndex: 0
            });
        });

        let option = {};
        if (node.extras.options) {
            option = node.extras.options
        }
        option.viewData = {
            x: node.x + 10,
            y: node.y + 10
        }

        nodeList.push({
            component: null,
            inLogicId: node.id,
            id: node.id,
            name: node.name,
            blockDescription: node.blockDescription,
            options: option,
            sectionType: node.sectionType,
            title: node.title,
            type: node.extras.type,
            ports: portData
        });
    });

    Object.values(distributedModel.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach((link) => {
        portList.push({
            id: link.id,
            fromPort: {
                id: link.sourcePort,
                node: link.source
            },
            toPort: {
                id: link.targetPort,
                node: link.target
            }
        });
    });

    graphData.nodes = nodeList;
    graphData.edges = portList;
    setUpLogic(thisElement);

    // thisElement.forceUpdate();
    thisElement.logicAllFunctions();
}

export function removeSelected(thisElement) {
    const engine = thisElement.state.engine;
    const model = engine.getModel();
    const selectedNodes = model.getSelectedEntities();
    if (selectedNodes.filter(node => node instanceof CustomNodeModel &&
        (node.nodeName === "output" || node.nodeName === "basic_output")).length) {
        thisElement.props.showToastForFrontend(messageCodes.REMOVE_ERROR);
    } else {
        Lodash.forEach(selectedNodes, (item) => {
            item.remove();
        });
    }
    engine.repaintCanvas();
}

export function removeUnconnectedEdges(thisElement) {
    const engine = thisElement.state.engine;
    const model = engine.getModel();
    const edges = model.getModels().filter(item => item instanceof DefaultLinkModel);
    Lodash.forEach(edges, (item) => {
        if (!item.sourcePort || !item.targetPort) {
            item.remove();
        }
    });
    engine.repaintCanvas();
}

export function updateDiagram(thisElement) {
    const engine = thisElement.state.engine;
    
    const model = thisElement.state.engine.getModel();
    const diagramModel = new DiagramModel();
    diagramModel.setOffset(model.getOffsetX(), model.getOffsetY());
    diagramModel.setZoomLevel(model.getZoomLevel());

    engine.setModel(diagramModel);
    setUpLogic(thisElement);
    engine.repaintCanvas();    
    thisElement.logicAllFunctions();
}

export function clearAll(thisElement) {
    const engine = thisElement.state.engine;
    const {initialGraph: {nodes, edges, data}, graphData} = thisElement.props;
    const model = new DiagramModel();
    engine.setDiagramModel(model);
    graphData.nodes = nodes;
    graphData.edges = edges;
    graphData.data = data
    setUpLogic(thisElement);
    engine.repaintCanvas();    
    thisElement.logicAllFunctions();
}

export function nodeOptionUpdate(thisElement) {
    const nodeID = thisElement.props.clickedNodeInfo.options.id;
    const model = thisElement.state.engine.getModel();
    const data = model.serialize();
    const result = Object.values(data.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).filter(node => node.id === nodeID)[0];

    if (result?.extras && thisElement.props?.clickedNodeInfo?.extras) {
        result.extras = thisElement.props.clickedNodeInfo.extras;
    }

    if (result?.extras?.name || result?.extras?.name === '') {
        updateDiagramModel(thisElement, result, "name", result?.extras?.name);
    } else if (result?.extras?.title || result?.extras?.title === '') {
        updateDiagramModel(thisElement, result, "title", result.extras.title);
    }

    if (result?.extras && !result?.extras?.options?.changedMark) {
        result.extras = {
            ...result?.extras,
            options: {
                ...result?.extras?.options,
                changedMark: true,
            }
        }
        updateDiagramModel(thisElement, result, "changedMark", true)
    }

    // thisElement.forceUpdate();
    thisElement.logicAllFunctions();
}

export function rebuildLogicGraph(thisElement) {
    const graphData = thisElement.props.graphData;

    const model = thisElement.state.engine.getModel();
    const data = model.serialize();
    const diagramModel = new DiagramModel();
    diagramModel.setOffset(model.getOffsetX(), model.getOffsetY());
    diagramModel.setZoomLevel(model.getZoomLevel())
    thisElement.state.engine.setModel(diagramModel);

    const portData = [];
    const edgeData = [];
    thisElement.props.logicGraphData.portList.forEach((v) => {
        portData.push({
            id: v.id,
            input: v.in,
            label: null,
            node: v.parentID,
            portIndex: 0
        });
    });

    Object.values(data.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach(v => {
        if (v.source === thisElement.props.clickedNodeInfo.options.id) {
            const portID = v.sourcePort;
            const result = thisElement.props.logicGraphData.portList.filter(port => port.id === portID);
            if (result.length > 0) {
                edgeData.push({
                    fromPort: {
                        id: v.sourcePort,
                        node: v.source
                    },
                    id: v.id,
                    toPort: {
                        id: v.targetPort,
                        node: v.target
                    }
                });
            }
        } else if (v.target === thisElement.props.clickedNodeInfo.options.id) {
            const portID = v.targetPort;
            const result = thisElement.props.logicGraphData.portList.filter(port => port.id === portID);
            if (result.length > 0) {
                edgeData.push({
                    fromPort: {
                        id: v.sourcePort,
                        node: v.source
                    },
                    id: v.id,
                    toPort: {
                        id: v.targetPort,
                        node: v.target
                    }
                });
            }
        } else {
            edgeData.push({
                fromPort: {
                    id: v.sourcePort,
                    node: v.source
                },
                id: v.id,
                toPort: {
                    id: v.targetPort,
                    node: v.target
                }
            });
        }
    });

    const nodeList = [];
    Object.values(data.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).forEach(node => {
        const portData = [];
        node.ports.forEach(port => {
            portData.push({
                id: port.id,
                input: port.in,
                label: null,
                node: port.parentNode,
                portIndex: 0
            });
        });
        let option = node.extras.options ? node.extras.options : {};
        if (node.id === thisElement.props.logicGraphData.id) {
            option = thisElement.props.logicGraphData.options;
        }

        option.viewData = {
            x: node.x,
            y: node.y,
        };
        nodeList.push({
            component: null,
            inLogicId: node.id,
            id: node.id,
            name: node.name,
            blockDescription: node.blockDescription,
            options: option,
            sectionType: node.sectionType,
            title: node.title,
            type: node.extras.type,
            ports: portData
        });
    });

    graphData.nodes = nodeList;
    graphData.edges = edgeData;
    const nodeIndex = graphData.nodes.map(node => {
        return node.id;
    }).indexOf(thisElement.props.clickedNodeInfo.options.id);

    graphData.nodes[nodeIndex].ports = portData;

    setUpLogic(thisElement);

    thisElement.state.engine.repaintCanvas();
    thisElement.logicAllFunctions();
    thisElement.props.logicDataActions(thisElement.state.engine);
}

const updateDiagramModel = (thisElement, result, property, value) => {
    const model = thisElement.state.engine.getModel();
    const diagramModel = new DiagramModel();
    const diagramData = model.serialize();
    thisElement.state.engine.setModel(diagramModel);

    let graphData = thisElement.props.graphData;
    const nodeList = [];
    const portList = [];

    Object.values(diagramData.layers.filter(layer => layer.type === 'diagram-nodes')[0].models).forEach(node => {
        const portData = [];
        node.ports.forEach(port => {
            portData.push({
                id: port.id,
                input: port.in,
                label: null,
                node: port.parentNode,
                portIndex: 0
            });
        });

        node[property] = node.id === result.id ? value : node[property];
        let option = node.id === result.id ? result.extras.options : node.extras.options;

        option.viewData = {
            x: node.x,
            y: node.y,
        };
        nodeList.push({
            component: null,
            inLogicId: node.id,
            id: node.id,
            name: node.name,
            blockDescription: node.blockDescription,
            options: option,
            sectionType: node.sectionType,
            title: node.title,
            type: node.extras.type,
            ports: portData
        });
    });

    Object.values(diagramData.layers.filter(layer => layer.type === 'diagram-links')[0].models).forEach((link) => {
        portList.push({
            id: link.id,
            fromPort: {
                id: link.sourcePort,
                node: link.source
            },
            toPort: {
                id: link.targetPort,
                node: link.target
            }
        });
    });

    graphData.nodes = nodeList;
    graphData.edges = portList
    diagramModel.setOffset(model.getOffsetX(), model.getOffsetY());
    diagramModel.setZoomLevel(model.getZoomLevel())
    setUpLogic(thisElement);
}

const getDistributedModel = (engine) => {
    const model = engine.getModel();
    const serialized = model.serialize();
    const distributedSerializedDiagram = distributeElements(serialized);
    return distributedSerializedDiagram;
}

const removeEmptyFields = (objects) => {
    if (!Array.isArray(objects)) {
        objects = [objects];
    }
    objects.forEach(object => {
        const keys = Object.keys(object);
        keys.forEach(key => {
            const value = object[key];
            if (isObject(value)) {
                if ((Array.isArray(value) && value.length === 0) || Object.keys(value).length === 0 || _.isEqual(defaultOptions[key], value)) {
                    delete object[key];
                } else {
                    removeEmptyFields(value);
                }
            } else {
                if (value === null) {
                    delete object[key];
                }
            }
        })
    })
}

const isObject = (obj) => {
    return obj != null && typeof obj === 'object';
}

const getInputPortDebugInfo = (port, edge, debugInfo) => {
    return debugInfo?.inputNodeInfo?.filter(info => info.nodeName.includes('_' + port.parent.options.id + '_') && info.inputNodeName.includes('_' + edge.fromPort.node + '_'))[0];
}

const getOutputPortDebugInfo = (port, debugInfo) => {
    let size = debugInfo?.outputNodeInfo?.filter(info => info.nodeName.includes('_' + port.parent.options.id + '_')).length;
    return debugInfo?.outputNodeInfo?.filter(info => info.nodeName.includes('_' + port.parent.options.id + '_'))[size-1];
}

const shouldMarkNodeAsUnused = (nodeId, nodeType, debugInfo) => {
    if (!debugInfo?.outputNodeInfo || nodeType === 'basic_output' || nodeType === 'output') {
        return false;
    }
    return !debugInfo.outputNodeInfo.some(outInfo => outInfo.nodeName.includes('_' + nodeId + '_'));
}
